import { render, staticRenderFns } from "./page-xuetang.vue?vue&type=template&id=29f54eeb&"
import script from "./page-xuetang.vue?vue&type=script&lang=js&"
export * from "./page-xuetang.vue?vue&type=script&lang=js&"
import style0 from "./page-xuetang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports